import styled from 'styled-components';
import { device } from '../../styles/stylesheets';

export const ContainerShadowStyled = styled.a`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.05);
  @media ${device.untilTablet} {
    border-radius: 4px;
  }
`;
